import { Injectable, inject } from '@angular/core';
import { Navigation } from 'app/core/navigation/navigation.types';
import { Observable, ReplaySubject, of } from 'rxjs';
import { Router } from '@angular/router';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { MatSnackBarModule } from '@angular/material/snack-bar'
import { MatSnackBar } from '@angular/material/snack-bar'
import { AuthService } from 'app/core/auth/auth.service';


@Injectable({ providedIn: 'root' })
export class NavigationService {
    private _navigation: ReplaySubject<Navigation> =
        new ReplaySubject<Navigation>(1);
	private _snackBar = inject(MatSnackBar);

    _defaultNavigation: FuseNavigationItem[] = [
        {
            id: 'home',
            title: 'Inicio',
            type: 'basic',
            icon: 'heroicons_outline:chart-pie',
            link: '/dashboard',
        },
        {
            id: 'balance',
            title: 'Saldos',
            type: 'basic',
            icon: 'heroicons_outline:scale',
            link: '/balance',
        },
        {
            id: 'invoices',
            title: 'Facturas',
            type: 'collapsable',
            icon: 'heroicons_outline:currency-dollar',
            // link: '/invoices',
            children: [
                {
                    id: 'invoices-ppd',
                    title: 'Facturas PPD',
                    type: 'collapsable',
                    icon: 'heroicons_outline:currency-dollar',
                    children: [
                        {
                            id: 'invoices-correct',
                            title: 'Facturas en proceso',
                            type: 'basic',
                            link: '/invoices-ppd-correct',
                            function: () => {
                                localStorage.setItem('filtersInvoices', JSON.stringify({
                                    state: [
                                        'draft', 'in_review', 'rejected', 'payment_validation_pue', 'in_emission_pue',
                                        'in_emission_pue_no_payment', 'issued_pue_no_payment', 'in_emission_ppd', 'awaiting_payment_ppd',
                                        'payment_validation_ppd', 'in_emission_rep'
                                    ],
                                    date: 'desc',
                                    origin: 'process',
                                    type: 'PPD'
                                }));
                            }
                        },
                        {
                            id: 'invoices-all',
                            title: 'Todas las facturas',
                            type: 'basic',
                            link: '/invoices-ppd',
                            function: () => {
                                localStorage.setItem('filtersInvoices', JSON.stringify({
                                    date: 'desc',
                                    origin: 'all',
                                    type: 'PPD'
                                }));
                            }
                        },
                        
                        {
                            id: 'invoices-not-generated',
                            title: 'Facturas finalizadas',
                            type: 'basic',
                            link: '/invoices-ppd-not-generated',
                            function: () => {
                                localStorage.setItem('filtersInvoices', JSON.stringify({
                                    state: ['posted'],
                                    date: 'desc',
                                    origin: 'finalized',
                                    type: 'PPD'
                                }));
                            }
                        }
                    ]
                },
                {
                    id: 'invoices-pue',
                    title: 'Facturas PUE',
                    type: 'collapsable',
                    icon: 'heroicons_outline:currency-dollar',
                    children: [
                        {
                            id: 'invoices-correct',
                            title: 'Facturas en proceso',
                            type: 'basic',
                            link: '/invoices-pue-correct',
                            function: () => {
                                localStorage.setItem('filtersInvoices', JSON.stringify({
                                    state: [
                                        'draft', 'in_review', 'rejected', 'payment_validation_pue', 'in_emission_pue',
                                        'in_emission_pue_no_payment', 'issued_pue_no_payment', 'in_emission_ppd', 'awaiting_payment_ppd',
                                        'payment_validation_ppd', 'in_emission_rep'
                                    ],
                                    date: 'desc',
                                    origin: 'process',
                                    type: 'PUE'
                                }));
                            }
                        },
                        {
                            id: 'invoices-all',
                            title: 'Todas las facturas',
                            type: 'basic',
                            link: '/invoices-pue',
                            function: () => {
                                localStorage.setItem('filtersInvoices', JSON.stringify({
                                    date: 'desc',
                                    origin: 'all',
                                    type: 'PUE'
                                }));
                            }
                        },
                        
                        {
                            id: 'invoices-not-generated',
                            title: 'Facturas finalizadas',
                            type: 'basic',
                            link: '/invoices-pue-not-generated',
                            function: () => {
                                localStorage.setItem('filtersInvoices', JSON.stringify({
                                    state: ['posted'],
                                    date: 'desc',
                                    origin: 'finalized',
                                    type: 'PUE'
                                }));
                            }
                        }
                    ]
                },

            ],
        },
        {
            id: 'payment-vouchers',
            title: 'Comprobantes de pago',
            type: 'collapsable',
            icon: 'heroicons_outline:clipboard-document-check',
            // link: '/payment-without',
            children: [
                {
                    id: 'payment-vouchers-all',
                    title: 'Todos los comprobantes',
                    type: 'basic',
                    link: '/payment-vouchers',
                    function: () => {
                        localStorage.setItem('filtersPaymentVouchers', JSON.stringify({
                            date: 'desc',
                            origin: 'all'
                        }));
                    }
                },
                {
                    id: 'payment-vouchers-process',
                    title: 'Comprobantes en proceso',
                    type: 'basic',
                    link: '/payment-vouchers-process',
                    function: () => {
                        localStorage.setItem('filtersPaymentVouchers', JSON.stringify({
                            state: ['draft', 'review', 'stand_by_application', 'partial_applied'],
                            date: 'desc',
                            origin: 'process'
                        }));
                    }
                },
                {
                    id: 'payment-vouchers-finalized',
                    title: 'Comprobantes finalizados',
                    type: 'basic',
                    link: '/payment-vouchers-finalized',
                    function: () => {
                        localStorage.setItem('filtersPaymentVouchers', JSON.stringify({
                            state: ['applied'],
                            date: 'desc',
                            origin: 'finalized'
                        }));
                    }
                }
            ],
        },
        {
            id: 'payment-without-invoice',
            title: 'Depósitos sin factura',
            type: 'collapsable',
            icon: 'heroicons_outline:ticket',
            children: [
                {
                    id: 'payment-without-invoice-all',
                    title: 'Todos los depósitos sin factura',
                    type: 'basic',
                    link: '/payment-without-invoice',
                    function: () => {
                        localStorage.setItem('filtersPaymentWithoutInvoice', JSON.stringify({
                            date: 'desc',
                            origin: 'all'
                        }));
                    }
                },
                {
                    id: 'payment-without-invoice-process',
                    title: 'Depósitos sin factura en proceso',
                    type: 'basic',
                    link: '/payment-without-invoice-process',
                    function: () => {
                        localStorage.setItem('filtersPaymentWithoutInvoice', JSON.stringify({
                            state: ['draft', 'request_send', 'waiting_payment', 'payment_validation'],
                            date: 'desc',
                            origin: 'process'
                        }));
                    }
                },
                {
                    id: 'payment-without-invoice-finalized',
                    title: 'Depósitos sin factura finalizados',
                    type: 'basic',
                    link: '/payment-without-invoice-finalized',
                    function: () => {
                        localStorage.setItem('filtersPaymentWithoutInvoice', JSON.stringify({
                            state: ['done'],
                            date: 'desc',
                            origin: 'finalized'
                        }));
                    }
                }
            ],
        },

        {
            id: 'payment-cash-banking',
            title: 'Bancarización de efectivo',
            type: 'collapsable',
            icon: 'heroicons_outline:banknotes',
            children: [
                {
                    id: 'payment-cash-banking-all',
                    title: 'Todas las bancarizaciones de efectivo',
                    type: 'basic',
                    link: '/payment-cash-banking',
                    function: () => {
                        localStorage.setItem('filtersPaymentCashBanking', JSON.stringify({
                            date: 'desc',
                            origin: 'all'
                        }));
                    }
                },
                {
                    id: 'payment-cash-banking-process',
                    title: 'Bancarizaciones de efectivo en proceso',
                    type: 'basic',
                    link: '/payment-cash-banking-process',
                    function: () => {
                        localStorage.setItem('filtersPaymentCashBanking', JSON.stringify({
                            state: ['draft', 'request_send', 'waiting_payment', 'payment_validation'],
                            date: 'desc',
                            origin: 'process'
                        }));
                    }
                },
                {
                    id: 'payment-cash-banking-finalized',
                    title: 'Bancarizaciones de efectivo finalizadas',
                    type: 'basic',
                    link: '/payment-cash-banking-finalized',
                    function: () => {
                        localStorage.setItem('filtersPaymentCashBanking', JSON.stringify({
                            state: ['done'],
                            date: 'desc',
                            origin: 'finalized'
                        }));
                    }
                }
            ],
        },

        {
            id: 'return',
            title: 'Retornos',
            type: 'collapsable',
            icon: 'heroicons_outline:arrow-uturn-left',
            children: [
                {
                    id: 'all',
                    title: 'Todos los retornos',
                    type: 'basic',
                    link: '/return-all',
                    function: () => {
                        localStorage.setItem('filtersReturn', JSON.stringify({
                            date: 'desc',
                            origin: 'all',
                            return_type_id: '',
                            return_type_money: ''
                        }));
                    }
                },
                {
                    id: 'return-cash',
                    title: 'Efectivo',
                    type: 'collapsable',
                    icon: 'heroicons_outline:banknotes',
                    children: [
                        {
                            id: 'cash-all',
                            title: 'Todos los efectivos',
                            type: 'basic',
                            link: '/return-cash-all',
                            function: () => {
                                localStorage.setItem('filtersReturn', JSON.stringify({
                                    date: 'desc',
                                    origin: 'all',
                                    return_type_id: '',
                                    return_type_money: 'cash'
                                }));
                            }
                        },
                        {
                            id: 'local-cash',
                            title: 'Efectivo local',
                            type: 'basic',
                            link: '/return-cash-local',
                            function: () => {
                                localStorage.setItem('filtersReturn', JSON.stringify({
                                    date: 'desc',
                                    origin: 'all',
                                    return_type_id: 1,
                                    return_type_money: 'cash'
                                }));
                            }
                        },
                        {
                            id: 'cash-values',
                            title: 'Efectivo con valores',
                            type: 'basic',
                            link: '/return-cash-values',
                            function: () => {
                                localStorage.setItem('filtersReturn', JSON.stringify({
                                    date: 'desc',
                                    origin: 'all',
                                    return_type_id: 2,
                                    return_type_money: 'cash'
                                }));
                            }
                        },
                        {
                            id: 'cash-foreign',
                            title: 'Efectivo foráneo',
                            type: 'basic',
                            link: '/return-cash-foreign',
                            function: () => {
                                localStorage.setItem('filtersReturn', JSON.stringify({
                                    date: 'desc',
                                    origin: 'all',
                                    return_type_id: 3,
                                    return_type_money: 'cash'
                                }));
                            }
                        },
                        // {
                        //     id: 'cash-deposit',
                        //     title: 'Deposito en efectivo',
                        //     type: 'basic',
                        //     link: '/return-cash-deposit',
                        //     function: () => {
                        //         localStorage.setItem('filtersReturn', JSON.stringify({
                        //             date: 'desc',
                        //             origin: 'all',
                        //             return_type_id: 4,
                        //             return_type_money: 'cash'
                        //         }));
                        //     }
                        // },
                        {
                            id: 'cash-all',
                            title: 'Deposito en efectivo',
                            type: 'basic',
                            link: '/return-cash-deposit-all',
                            function: () => {
                                localStorage.setItem('filtersReturn', JSON.stringify({
                                    date: 'desc',
                                    origin: 'all',
                                    return_type_id: '',
                                    return_type_money: 'cash_deposit'
                                }));
                            }
                        },
                    ]
                },
                {
                    id: 'return-transfer',
                    title: 'Transferencia',
                    type: 'collapsable',
                    icon: 'heroicons_outline:banknotes',
                    children: [
                        {
                            id: 'transfers-all',
                            title: 'Todas las transferencias',
                            type: 'basic',
                            link: '/return-transfers-all',
                            function: () => {
                                localStorage.setItem('filtersReturn', JSON.stringify({
                                    date: 'desc',
                                    origin: 'all',
                                    return_type_id: '',
                                    return_type_money: 'transf'
                                }));
                            }
                        },
                        {
                            id: 'national-transfers',
                            title: 'Transferencias nacionales',
                            type: 'basic',
                            link: '/return-transfers-national',
                            function: () => {
                                localStorage.setItem('filtersReturn', JSON.stringify({
                                    date: 'desc',
                                    origin: 'all',
                                    return_type_id: 5,
                                    return_type_money: 'transf'
                                }));
                            }
                        },
                        {
                            id: 'international-transfers',
                            title: 'Transferencias internacionales',
                            type: 'basic',
                            link: '/return-transfers-international',
                            function: () => {
                                localStorage.setItem('filtersReturn', JSON.stringify({
                                    date: 'desc',
                                    origin: 'all',
                                    return_type_id: 6,
                                    return_type_money: 'transf'
                                }));
                            }
                        },
                        {
                            id: 'payroll',
                            title: 'Nómina',
                            type: 'basic',
                            link: '/return-transfers-payroll',
                            function: () => {
                                localStorage.setItem('filtersReturn', JSON.stringify({
                                    date: 'desc',
                                    origin: 'all',
                                    return_type_id: 7,
                                    return_type_money: 'transf'
                                }));
                            }
                        },
                        {
                            id: 'assimilated-salaries',
                            title: 'Asimilados a salarios',
                            type: 'basic',
                            link: '/return-transfers-assimilated',
                            function: () => {
                                localStorage.setItem('filtersReturn', JSON.stringify({
                                    date: 'desc',
                                    origin: 'all',
                                    return_type_id: 8,
                                    return_type_money: 'transf'
                                }));
                            }
                        },
                        {
                            id: 'foreign-exchange',
                            title: 'Divisas',
                            type: 'basic',
                            link: '/return-transfers-forex',
                            function: () => {
                                localStorage.setItem('filtersReturn', JSON.stringify({
                                    date: 'desc',
                                    origin: 'all',
                                    return_type_id: 9,
                                    return_type_money: 'transf'
                                }));
                            }
                        },
                    ]
                },
            ],
        },

        {
            id: 'requests',
            title: 'Mesa de ayuda',
            type: 'basic',
            icon: 'heroicons_outline:question-mark-circle',
            link: '/requests',
        },
        
       
        {
            id: 'profile',
            title: 'Perfil',
            type: 'basic',
            icon: 'heroicons_outline:user',
            link: '/profile',
        },
        {
            id: 'sing-out',
            title: 'Cerrar sesión',
            type: 'basic',
            icon: 'heroicons_outline:arrow-right-on-rectangle',
            function: () => {
				this.redirectLogIn('Se ha actualizado su contraseña.')
			}
        },
    ];

    constructor(
		private _router: Router,
		private _authService: AuthService,
		) {
		// this.loadDynamicNavigation();
	}

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for navigation
     */
    get navigation$(): Observable<Navigation> {
        return this._navigation.asObservable();
    }

    // Cierre de sesion
	redirectLogIn(message: any){
		this._authService.signOut().subscribe({
			next: (res) => {
				this._router.navigate(['sign-in']);
				this.openSnackBar(message, true);
			},
			error: (error) => {
				console.error('Error en la petición:', error);
				//Redirigue automaticamente al inicio de sesion
				this._router.navigate(['sign-in']);
				this.openSnackBar(message, true);
			}
		});
	}
	//Mensaje
	openSnackBar(message: string, isSuccess: boolean): void {
		this._snackBar.open(message, '', {
		  horizontalPosition: 'right',
		  verticalPosition: 'top',
		  duration: 4000,
		  panelClass: [isSuccess ? 'success-snackbar' : 'error-snackbar', 'center-text-snackbar'],
		});
	  }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get all navigation data
     */
    get(): Observable<Navigation> {
        let navigation = {
            default: this._defaultNavigation,
        };
        this._navigation.next(navigation);
        return of(navigation);
    }
}
